<ng-container *ngIf="galleryItems && galleryItems.length > 0">
    <div class="product-gallery">
        <div class="main-image" [ngClass]="productFinish ? 'product-finish' : 'product-fabric'">
            <div *ngIf="isSizeMd" class="flex justify-center items-center">
                <img [src]="galleryItems[selectedImageIndex].type === 'image'? galleryItems[selectedImageIndex].src: galleryItems[selectedImageIndex].poster"
                     (click)="openGallery(selectedImageIndex)"
                     class="cursor-pointer"
                     [alt]="galleryItems[selectedImageIndex].alt" />
            </div>

            <div *ngIf="!isSizeMd"
				 class="flex justify-center items-center"
                 fbSwipe
                 (next)="nextImage(selectedImageIndex)"
                 (previous)="prevImage(selectedImageIndex)"
                 >
                <img *ngIf="galleryItems[selectedImageIndex].type === 'image'"
                     [src]="galleryItems[selectedImageIndex].src"
                     (click)="openGallery(selectedImageIndex)"
                     class="cursor-pointer"
                     [alt]="galleryItems[selectedImageIndex].alt" />

                <img *ngIf="galleryItems[selectedImageIndex].type !== 'image'"
                     [src]="galleryItems[0].src"
                     (click)="openGallery(selectedImageIndex)"
                     class="cursor-pointer"
                     [alt]="galleryItems[selectedImageIndex].alt" />

                <img *ngIf="galleryItems[selectedImageIndex].type !== 'image'"
                     class="shorts-thumb"
                     src="assets/img/youtube_shorts_icon.svg" [alt]="galleryItems[selectedImageIndex].alt">
            </div>

            <div *ngIf="hasVideo"
                 (click)="openGallery(1)"
                 class="absolute bottom-5 left-5 w-10 h-10 rounded-full bg-white flex justify-center items-center cursor-pointer">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.5625 15.5156V8.48438C3.5625 7.98709 3.76004 7.51018 4.11167 7.15855C4.46331 6.80692 4.94022 6.60938 5.4375 6.60938H13.4062C13.9035 6.60938 14.3804 6.80692 14.7321 7.15855C15.0837 7.51018 15.2812 7.98709 15.2812 8.48438V15.5156C15.2812 16.0129 15.0837 16.4898 14.7321 16.8415C14.3804 17.1931 13.9035 17.3906 13.4062 17.3906H5.4375C4.94022 17.3906 4.46331 17.1931 4.11167 16.8415C3.76004 16.4898 3.5625 16.0129 3.5625 15.5156ZM19.6575 7.30406L15.9075 10.6444C15.8581 10.6883 15.8185 10.7421 15.7914 10.8024C15.7642 10.8626 15.7501 10.928 15.75 10.9941V12.6609C15.7501 12.727 15.7642 12.7924 15.7914 12.8526C15.8185 12.9129 15.8581 12.9667 15.9075 13.0106L19.6575 16.3509C19.7251 16.4109 19.8085 16.4501 19.8978 16.4638C19.9872 16.4775 20.0785 16.465 20.1609 16.428C20.2434 16.3909 20.3133 16.3309 20.3624 16.255C20.4114 16.1791 20.4375 16.0907 20.4375 16.0003V7.65469C20.4375 7.56433 20.4114 7.47589 20.3624 7.40002C20.3133 7.32414 20.2434 7.26407 20.1609 7.22702C20.0785 7.18998 19.9872 7.17754 19.8978 7.19121C19.8085 7.20487 19.7251 7.24407 19.6575 7.30406Z" stroke="#7D5A20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>

            <div (click)="openGallery(0)"
                 class="absolute bottom-5 right-5 w-10 md:w-auto h-10 rounded-full bg-white flex justify-center items-center gap-1 md:px-2 cursor-pointer">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_2120_299)">
                        <path d="M14.7808 2.91667C14.5508 2.07333 13.8267 1.46417 12.9171 1.39875C11.8521 1.32208 10.2771 1.25 8.125 1.25C5.98583 1.25 4.4175 1.32125 3.35292 1.3975C2.2875 1.47333 1.47292 2.2875 1.39708 3.35333C1.32083 4.41792 1.25 5.98667 1.25 8.125C1.25 10.2771 1.3225 11.8517 1.39875 12.9167C1.46417 13.8262 2.07375 14.5508 2.91667 14.7804" stroke="#7D5A20" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M5.1475 7.10292C5.22333 6.0375 6.0375 5.22375 7.10333 5.1475C8.1675 5.07083 9.73625 5 11.875 5C14.0137 5 15.5821 5.07125 16.6467 5.1475C17.7125 5.22333 18.5267 6.0375 18.6025 7.10333C18.6787 8.16792 18.75 9.73667 18.75 11.875C18.75 14.0137 18.6787 15.5821 18.6025 16.6471C18.5267 17.7125 17.7125 18.5262 16.6467 18.6025C15.5821 18.6787 14.0133 18.75 11.875 18.75C9.73625 18.75 8.16792 18.6787 7.10292 18.6025C6.0375 18.5267 5.22375 17.7125 5.1475 16.6467C5.07083 15.5825 5 14.0137 5 11.875C5 9.73625 5.07125 8.16792 5.1475 7.10292Z" stroke="#7D5A20" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.6858 15.1621C17.7462 14.2812 17.0692 13.6946 16.5992 13.3104C16.0417 12.8542 15.3067 12.7879 14.7062 13.1883C14.2437 13.4967 13.6087 13.9675 12.7792 14.6796C11.5458 13.5 10.6958 12.7587 10.1383 12.3025C9.58083 11.8462 8.84583 11.7804 8.24541 12.1804C7.57041 12.6304 6.5275 13.4271 5.05042 14.8129" stroke="#7D5A20" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M13.3333 9.16663C13.3333 9.49815 13.465 9.81609 13.6994 10.0505C13.9339 10.2849 14.2518 10.4166 14.5833 10.4166C14.9148 10.4166 15.2328 10.2849 15.4672 10.0505C15.7016 9.81609 15.8333 9.49815 15.8333 9.16663C15.8333 8.83511 15.7016 8.51716 15.4672 8.28274C15.2328 8.04832 14.9148 7.91663 14.5833 7.91663C14.2518 7.91663 13.9339 8.04832 13.6994 8.28274C13.465 8.51716 13.3333 8.83511 13.3333 9.16663Z" stroke="#7D5A20" stroke-width="1.125" stroke-linecap="round" stroke-linejoin="round"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2120_299">
                            <rect width="20" height="20" fill="white"/>
                        </clipPath>
                    </defs>
                </svg>
				<span class="hidden md:block text-xs primary-brown-text">View Gallery</span>
            </div>
        </div>


        <div *ngIf="isSizeMd" class="thumbnail-wrapper ">
            <button *ngIf="showArrows"
                    class="arrow left cursor-pointer" (click)="scrollThumbnails('left')">&#8249;</button>

            <div class="thumbnails cursor-pointer"
                 [ngClass]="showArrows? 'thumbnails-arrow-padding': 'thumbnails-padding'"
                 #thumbnailContainer>
                <div *ngFor="let image of galleryItems;let i = index"
					 class="thumbnail-container relative flex-shrink-0"
					 [class.active]="i === selectedImageIndex">
                    <img [src]="image.type === 'image' ? image.thumb : image.poster"
                            (click)="selectImage(i)"
                            [alt]="image.alt"
                    />
                    <img *ngIf="image.type !== 'image'"
                         class="shorts-thumb"
                         src="assets/img/youtube_shorts_icon.svg" [alt]="image.alt">
                </div>
            </div>
            <button *ngIf="showArrows"
                    class="arrow right cursor-pointer" (click)="scrollThumbnails('right')">&#8250;</button>
        </div>

        <div *ngIf="!isSizeMd">
            <div class="circular-thumbnails cursor-pointer"
                 #thumbnailContainer>
                <div class="" *ngFor="let image of galleryItems;let i = index">
                   <div *ngIf="image.type === 'image'"
                        (click)="selectImage(i)"
                        class="circular-control"
                        [class.active]="i === selectedImageIndex"></div>
                   <div *ngIf="image.type !== 'image'"
                        (click)="selectImage(i)"
                        class="circular-control"
                        [class.active]="i === selectedImageIndex">
                       <div class="video-thumbnail"></div>
                   </div>
                </div>
            </div>
        </div>
    </div>

    <lightgallery
        #lightGallery
        [settings]="settings"
        [onInit]="onInit"
    >
    </lightgallery>
</ng-container>


